/** Fields used to pick a household snapshot when the display name is unknown. */
export type OpenworkClientSnapshotSource = {
  scenario_ref?: string | null;
};

/** Canonical client display names for OpenWork letter-review demo scenarios. */
export const OPENWORK_SCENARIO_CLIENT_NAMES: Record<string, string> = {
  "ow-james-sarah-mpgi": "James & Sarah Thompson",
  "ow-james-sarah-addendum": "James & Sarah Thompson",
  "ow-michael-roberts": "Michael Roberts",
  "ow-michael-roberts-addendum": "Michael Roberts",
  "ow-david-williams": "David Williams",
};

/** Resolve a demo client name when the task entity is not hydrated. */
export function openworkClientNameFromScenarioRef(
  scenarioRef: string | null | undefined,
): string | null {
  const ref = scenarioRef?.trim();
  if (!ref) return null;
  if (Object.hasOwn(OPENWORK_SCENARIO_CLIENT_NAMES, ref)) {
    return OPENWORK_SCENARIO_CLIENT_NAMES[ref];
  }
  if (ref.includes("james-sarah")) return OPENWORK_SCENARIO_CLIENT_NAMES["ow-james-sarah-mpgi"];
  if (ref.includes("michael-roberts")) return OPENWORK_SCENARIO_CLIENT_NAMES["ow-michael-roberts"];
  if (ref.includes("david-williams")) return OPENWORK_SCENARIO_CLIENT_NAMES["ow-david-williams"];
  return null;
}

/** Short household summary for OpenWork demo client cards. */
const OPENWORK_CLIENT_SNAPSHOTS: Record<string, string> = {
  "james & sarah thompson":
    "First-time buyers with one dependant. £325k purchase — mortgage and protection package in review.",
  "michael roberts":
    "Age 58, retiring in 7–10 years. Consolidating four pensions and taking £40k tax-free cash.",
  "david williams":
    "Age 68, retired. ~£1.6m estate — IHT mitigation and estate planning letter in review.",
};

export function openworkClientSnapshot(
  displayName: string,
  task?: OpenworkClientSnapshotSource,
): string {
  const fromName = OPENWORK_CLIENT_SNAPSHOTS[displayName.trim().toLowerCase()];
  if (fromName) return fromName;

  const fromScenario = openworkClientNameFromScenarioRef(task?.scenario_ref);
  if (fromScenario) {
    const snapshot = OPENWORK_CLIENT_SNAPSHOTS[fromScenario.toLowerCase()];
    if (snapshot) return snapshot;
  }

  return "Client profile and holdings are synced from your back office.";
}
